import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

const ActivityFeed = ({ activities = [] }) => {
  const { t } = useTranslation();
  const getActivityIcon = (type) => {
    switch (type) {
      case 'appointment_created':
        return 'Plus';
      case 'appointment_cancelled':
        return 'X';
      case 'appointment_completed':
        return 'Check';
      case 'staff_added':
        return 'UserPlus';
      case 'service_updated':
        return 'Settings';
      case 'client_registered':
        return 'UserCheck';
      default:
        return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'appointment_created':
        return 'text-primary';
      case 'appointment_cancelled':
        return 'text-error';
      case 'appointment_completed':
        return 'text-success';
      case 'staff_added':
        return 'text-accent';
      case 'service_updated':
        return 'text-secondary';
      case 'client_registered':
        return 'text-success';
      default:
        return 'text-text-secondary';
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const time = new Date(timestamp);
    const diffInMinutes = Math.floor((now - time) / (1000 * 60));
    
    if (diffInMinutes < 1) return t('common.now');
    if (diffInMinutes < 60) return `${diffInMinutes} min`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)} ${t('common.hours')}`;
    return `${Math.floor(diffInMinutes / 1440)} ${t('common.days')}`;
  };

  return (
    <div className="bg-background border border-border rounded-lg p-6">
      <h2 className="text-lg font-semibold text-foreground mb-6">{t('dashboard.recentActivity')}</h2>
      <div className="space-y-4">
        {activities?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Activity" size={48} className="mx-auto text-muted-foreground mb-4" />
            <p className="text-text-secondary">{t('dashboard.noActivity')}</p>
          </div>
        ) : (
          activities?.map((activity) => (
            <div key={activity?.id} className="flex items-start space-x-3">
              <div className={`w-8 h-8 rounded-full bg-muted flex items-center justify-center flex-shrink-0 ${getActivityColor(activity?.type)}`}>
                <Icon name={getActivityIcon(activity?.type)} size={16} />
              </div>
              
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground">
                  <span className="font-medium">{activity?.user}</span> {activity?.description}
                </p>
                <div className="flex items-center space-x-2 mt-1">
                  <span className="text-xs text-text-secondary">
                    {formatTimeAgo(activity?.timestamp)}
                  </span>
                  {activity?.details && (
                    <>
                      <span className="text-xs text-text-secondary">•</span>
                      <span className="text-xs text-text-secondary">{activity?.details}</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ActivityFeed;